import { sliceText } from "../../../utils/common";
import { safeString } from "../../../utils/logger";

export const DESIGNATION_INITIAL_STATE = {
  status: true,
  designationName: null,
  dept_id: null
}

export const DESIGNATION_API = {
  DESIGNATION_LIST: { URL: "/designation/", METHOD: "GET" },
  DESIGNATION_UPDATE: { url: "/designation/", method: "PUT" },
  DESIGNATION_CREATE: { url: "/designation/", method: "POST" },
  DEPARTMENT_LIST: { url: "/department/", method: "GET" }
}
export const DESIGNATION_INPUT_FIELDS = {
  status: {
    name: "status",
    label: "Status",
    type: "select",
    placeholder: "Type Here...",
    fullWidth: true,
    required: true,
    options: [
      { id: true, name: "Active" },
      { id: false, name: "Inactive" },
    ]
  },
  designationName: {
    name: "designationName",
    label: "Designation Name",
    type: "text",
    placeholder: "Type Here...",
    fullWidth: true,
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText((safeString(value)), 150);
        return value;
      }
    }
  },
  dept_id: {
    name: "dept_id",
    label: "Department Name",
    type: "select",
    // defaultValue:"",
    required: true,
    fullWidth: true,
  },
};